/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { RoleDropdownResponseDto } from '../model/roleDropdownResponseDto';
import { RolePaginationResponseDto } from '../model/rolePaginationResponseDto';
import { RoleRequestDto } from '../model/roleRequestDto';
import { RoleResponseDto } from '../model/roleResponseDto';
import { ValidationError } from '../model/validationError';


@Injectable({
  providedIn: 'root',
})
export class RolesService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public rolesDropdownGet$(page?: number, limit?: number, name?: string, isActive?: boolean, sort?: string): Observable<Array<RoleDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/roles/dropdown`, { page, limit, name, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public rolesGet$(page?: number, limit?: number, name?: string, isActive?: boolean, sort?: string): Observable<RolePaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/roles`, { page, limit, name, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public rolesIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/roles/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public rolesIdGet$(id: string): Observable<RoleResponseDto> {
    return this.api.get(`${apiBaseUrl()}/roles/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public rolesIdPut$(id: string, body: RoleRequestDto): Observable<RoleResponseDto> {
    return this.api.put(`${apiBaseUrl()}/roles/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public rolesIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/roles/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public rolesPost$(body: RoleRequestDto): Observable<RoleResponseDto> {
    return this.api.post(`${apiBaseUrl()}/roles`, body, undefined);
  }
}
